import { useEffect, useCallback, useState } from 'react';

export function useHorizontalScroll(status: string) {
	const [table, setTable] = useState<any>(document.querySelector(`div.ant-table-content`));

	useEffect(() => {
		setTable(document.querySelector(`div.ant-table-content`));
	}, [status]);

	const onWheel = useCallback(
		(e: WheelEvent) => {
			if (e.deltaY === 0) return;
			e.preventDefault();

			table.scrollTo({
				left: table.scrollLeft + e.deltaY,
				behavior: 'smooth',
			});
		},
		[table],
	);

	useEffect(() => {
		if (table?.clientWidth < table?.scrollWidth) {
			table?.addEventListener('wheel', onWheel);
		}
	}, [table, onWheel, status]);

	useEffect(() => {
		return () => table?.removeEventListener('wheel', onWheel);
	}, []);
}
